import { isTurListeFormName } from "@rpforms/shared/build/utilities";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { GenerateTarget } from "../../hooks/useGenerateOffer";

export const getFormName = (entry: any): string => {
    return entry?.form?.name || entry?.form?.label || "";
};

export const isLeistungsnachweisForm = (formName: string): boolean => {
    return formName.toLowerCase().includes("leistungsnachweis");
};

export const validateDocumentSelection = (
    target: GenerateTarget,
    selectedEntries: any[]
): string | null => {
    const docLabel = target === "invoice" ? "Rechnung" : "Angebot";

    if (selectedEntries.length === 0) {
        return "Bitte wählen Sie mindestens ein Formular aus";
    }

    if (target !== "invoice") {
        return null;
    }

    const uniqueFormNames = Array.from(
        new Set(selectedEntries.filter(Boolean).map((entry) => getFormName(entry)))
    );

    if (uniqueFormNames.length > 1) {
        return `Nur Formulare vom gleichen Typ können für ein ${docLabel} verwendet werden. Gefundene Typen: ${uniqueFormNames.join(
            ", "
        )}`;
    }

    if (
        uniqueFormNames.length === 1 &&
        isTurListeFormName(uniqueFormNames[0]) &&
        selectedEntries.length > 1
    ) {
        return `Für Türliste-Formulare kann nur ein Formular für ein ${docLabel} ausgewählt werden`;
    }

    return null;
};

interface IGenerateDocumentDropdownProps {
    selectedEntries: any[];
    isGenerating: boolean;
    onGenerate: (target: GenerateTarget) => void;
}

export const GenerateDocumentDropdown = ({
    selectedEntries,
    isGenerating,
    onGenerate,
}: IGenerateDocumentDropdownProps) => {
    const selectedFormNames = Array.from(
        new Set(selectedEntries.map((entry) => getFormName(entry)).filter(Boolean))
    );
    const allLeistungsnachweis =
        selectedFormNames.length > 0 && selectedFormNames.every(isLeistungsnachweisForm);
    const count = selectedEntries.length;

    return (
        <Dropdown>
            <Dropdown.Toggle variant="light" id="create-document-dropdown" disabled={isGenerating}>
                <i className="fa fa-fw fa-file-text" style={{ paddingRight: 4 }} />
                {isGenerating ? "Generiere..." : "Dokument erstellen"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item
                    onClick={() => onGenerate("offer")}
                    disabled={allLeistungsnachweis}
                    title={
                        allLeistungsnachweis
                            ? "Für Leistungsnachweise bitte Rechnung erstellen"
                            : undefined
                    }
                >
                    {`Angebot aus ${count} Formular${count > 1 ? "en" : ""}`}
                </Dropdown.Item>
                <Dropdown.Item
                    onClick={() => onGenerate("invoice")}
                    disabled={!allLeistungsnachweis}
                    title={
                        !allLeistungsnachweis ? "Nur für Leistungsnachweise verfügbar" : undefined
                    }
                >
                    {`Rechnung aus ${count} Leistungsnachweis${count > 1 ? "en" : ""}`}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
